import { Loader2 } from "lucide-react";
import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useFinanceModuleFlag } from "../hooks/useFinanceModuleFlag";

type FinanceAccessRouteProps = {
  children: ReactNode;
};

const FinanceAccessRoute = ({ children }: FinanceAccessRouteProps) => {
  const { enabled, loading } = useFinanceModuleFlag();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#f5f6fa] text-sm font-medium text-gray-500">
        <Loader2 className="mr-2 h-4 w-4 animate-spin text-[#2b5ce6]" />
        Cargando Fluxi Métricas...
      </div>
    );
  }

  if (!enabled) {
    return <Navigate to="/home" replace />;
  }

  return <>{children}</>;
};

export default FinanceAccessRoute;
